import React from 'react';
import { useSelector } from 'react-redux';

// Components
import WpUserInput from 'Wpds/components/user-input/WpUserInput';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

type Props = {
  addFilter: Function;
  selectedFilters: Array<any>;
};

const UserFilters = ({ addFilter, selectedFilters }: Props) => {
  const teamSyncWorkspace = useSelector(state => state.workspaces.find(({ isTeamSync }) => isTeamSync));

  const appliedOwnersFilters = selectedFilters.filter(filter => filter.type === 'owner');
  const hasOwnerFilters = appliedOwnersFilters.length > 0;

  // need to wait for workspaces fetch to get users
  if (!teamSyncWorkspace) return null;

  const handleSelectUser = user => {
    addFilter({ type: 'owner', label: user.label, ownerId: user.id });
  };

  const CustomInnerDropdown = () => {
    return (
      <WpButton variant={hasOwnerFilters ? 'primary' : 'tertiary'} size="sm" square slimPadding>
        Owner {hasOwnerFilters && <>({appliedOwnersFilters.length})</>} <WpIcon name="angle-down" />
      </WpButton>
    );
  };

  return (
    <WpUserInput
      id="owner-filter"
      label="Owner Filter"
      users={teamSyncWorkspace.users}
      labelHidden
      components={{ innerDropdown: CustomInnerDropdown }}
      onChange={handleSelectUser}
    />
  );
};

export default UserFilters;
